import { createAction, props } from '@ngrx/store';
import { FilterProperty, FilterValue } from './filters.reducer';

export const setFilterProp = createAction(
  '[Filters] Set filter property',
  props<{ name: FilterProperty, value: FilterValue }>()
);

export const resetFilters = createAction(
  '[Filters] Reset filters',
);

export const updateQueryParams = createAction(
  '[Filters] Update query params'
);

export const setBrandIds = createAction(
  '[Filters] Set brand ids',
  props<{ ids: (string | number)[] }>()
);

// TODO: dead in production — only setUpaIds$'s own spec dispatches this; no component does. Remove action + setUpaIds$ effect?
export const setUpaIds = createAction(
  '[Filters] Set UPA ids',
  props<{ ids: (string | number)[] }>()
);

// TODO: dead in production — only setCabinIds$'s own spec dispatches this; no component does. Remove action + setCabinIds$ effect?
export const setCabinIds = createAction(
  '[Filters] Set cabin ids',
  props<{ ids: (string | number)[] }>()
);

// TODO: fully dead — no dispatcher, no effect, no spec; airline filtering goes through setFilterProp(filteredAirlineIds) directly. Remove?
export const setAirlineIds = createAction(
  '[Filters] Set airline ids',
  props<{ ids: (string | number)[] }>()
);